module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a1-10-895113dc63d3e806bb0ec62edaf6cefb.jpg";